// /src/components/ProjectDescription.js
import React from "react";
import { useTranslation } from "react-i18next";
import "./ProjectDescription.css";

const ProjectDescription = ({ descKey }) => {
  const { t } = useTranslation();
  const desc = t(descKey);

  const splitIndex = desc.indexOf("(");
  const mainDesc = splitIndex > -1 ? desc.slice(0, splitIndex) : desc;
  const status = splitIndex > -1 ? desc.slice(splitIndex) : "";

  return (
    <span>
      {mainDesc}
      {status && <span className="highlight-status">{status}</span>}
    </span>
  );
};

export default ProjectDescription;
